import { initInvisibleRecaptcha } from "../libs/invisibleRecaptcha";

window.grecaptchaLoaded = function() {
	$(function() {
		// recaptcha badge shows only on input
		$('.g-recaptcha').hide();
		var formsWithCaptcha = '#frm-newsletterForm, #frm-newsletterFormModal';
		$(formsWithCaptcha).each(function () {
			const $form = $(this);
			const $input = $form.find('input');
			const $recaptcha = $form.find('.g-recaptcha');
			$input.on('focus', () => $recaptcha.fadeIn(100));
			$input.on('blur', () => $recaptcha.fadeOut(100));
		});

		initInvisibleRecaptcha(document, Nette, grecaptcha);
	});
}
